import React from "react";
import { NavLink } from 'react-router-dom';

function Navigationlink(props) {
    const collapsed = props.collapsed;
    return (
        <NavLink
            to={props.url}
            end={props.url === "/"}
            onClick={props.onNavigate}
            title={collapsed ? props.title : undefined}
            style={{ textDecoration: "none" }}
            className={({ isActive }) =>
                `group flex items-center ${collapsed ? "justify-center px-0" : "gap-3 px-3"} py-2.5 rounded-xl text-sm font-medium font-Rajdhani transition-colors duration-150 no-underline ${
                    isActive
                        ? "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-300"
                        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white"
                }`
            }
        >
            {({ isActive }) => (
                <>
                    <i className={`${props.class} text-lg ${isActive ? "text-indigo-600 dark:text-indigo-300" : "text-gray-400 group-hover:text-gray-600 dark:text-gray-500 dark:group-hover:text-gray-300"}`}></i>
                    {!collapsed && <span>{props.title}</span>}
                    {!collapsed && props.new && (
                        <span className="ml-auto text-[10px] font-semibold uppercase tracking-wide rounded-full px-1.5 py-0.5 bg-indigo-100 text-indigo-700 dark:bg-indigo-500/20 dark:text-indigo-300">
                            New
                        </span>
                    )}
                </>
            )}
        </NavLink>
    );
}

export default Navigationlink;
